import UserBar from './UserBar.container';

export default UserBar;
